import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditPenaltiesComponent } from './components/edit-penalties/edit-penalties.component';
import { EditFixedChargesComponent } from './components/edit-fixed-charges/edit-fixed-charges.component';
import { ChooseFarebasisComponent } from './components/choose-farebasis/choose-farebasis.component';
import { NoDifferenceValuesComponent } from './components/no-difference-values/no-difference-values.component';
import { SharedModule } from 'src/app/shared/shared.module';
import {
  AccordionModule,
  AlertModule,
  FareModule,
  InputFieldModule,
  InputSelectAddonModule,
  InputSubmitModule,
  InputSwitchModule,
  TabsModule,
  TinyAlertModule,
  ModalModule,
  DraggableListModule,
  DraggableListMlModule
} from 'src/app/components';

@NgModule({
  declarations: [
    EditFixedChargesComponent,
    EditPenaltiesComponent,
    ChooseFarebasisComponent,
    NoDifferenceValuesComponent
  ],
  exports: [
    EditFixedChargesComponent,
    EditPenaltiesComponent,
    ChooseFarebasisComponent,
    NoDifferenceValuesComponent
  ],
  imports: [
    CommonModule,
    DraggableListModule,
    DraggableListMlModule,
    FormsModule,
    AccordionModule,
    AlertModule,
    TinyAlertModule,
    TabsModule,
    InputSubmitModule,
    InputFieldModule,
    InputSelectAddonModule,
    InputSwitchModule,
    ModalModule,
    FareModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class ExchangeOverrideModule {}
